export const isValidPhone = (phoneNumber) => {
  const phoneNumberRegex = /^\+[1-9][0-9]{4,14}$/
  return phoneNumberRegex.test(phoneNumber)
}

type PhoneNumberType = { tel: number; countryCode: string }
export const validatePhoneNumber = (value: PhoneNumberType): PhoneNumberType | string => {
  if (!value.tel && !value.countryCode) {
    return 'This is required.'
  }

  if (!value.tel) {
    return 'Phone number is required.'
  }
  if (!value.countryCode) {
    return 'Country code is required.'
  }

  // Validate format
  const phoneNumber = value.countryCode + value.tel
  const isValid = isValidPhone(phoneNumber)
  if (!isValid) {
    return 'Invalid phone number'
  }

  return value || 'This is required.'
}
